import {
  GlobeAltIcon, // For "Explore"
  BriefcaseIcon, // For "Gigs/Job"
  BuildingOfficeIcon, // For "Studios"
  CalendarDaysIcon, // For "Events"
  MegaphoneIcon, // For "Weve" (represents announcements or company updates)
} from "@heroicons/react/24/outline";

export const navigation = [
  { name: "Explore", href: "#", icon: GlobeAltIcon, current: true },
  { name: "Gigs", href: "#", icon: BriefcaseIcon, current: false },
  { name: "Studios", href: "#", icon: BuildingOfficeIcon, current: false },
  { name: "Events", href: "#", icon: CalendarDaysIcon, current: false },
  { name: "Weve", href: "#", icon: MegaphoneIcon, current: false },
];

export const statuses = {
  Verified: "text-green-700 bg-green-50 ring-green-600/20",
  "In progress": "text-gray-600 bg-gray-50 ring-gray-500/10",
  Unverified: "text-yellow-800 bg-yellow-50 ring-yellow-600/20",
};

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
